jQuery(function(){

    var privateFunctions = {
        splitValues(input){
            if(!input)
                return [];
            if (!(typeof input == "string")) {
                input = input + "";
            }
            var splittedInput = input.split(",");
            var result = [];
            for(var i in splittedInput){
                if(isNaN(i))
                    continue;
                if(typeof splittedInput[i] === 'undefined')
                    continue;
                result.push(parseInt(splittedInput[i]));
                if(result.length >= 2)
                    return result;
            }
            return result;
        },
        joinValues(input,wNumbFormatter){
            if(!input)
                return "";
            if(!!wNumbFormatter){
                input = _.map(input,function(element){
                    return wNumbFormatter.from(element);
                });
            }
            return input.join(",");
        },
        initSliders(elements) {
            
            elements.each(function () {
                var $this = $(this);
                var eventsPostfix = $this.data('events-postfix') || null;
                var inputName = $this.data('input-name') || 'price';
                $this.data('input-name', inputName);    

                var checkboxLabel = $this.data('checkbox-label') || 'Aktivieren';   
                if($this.is("[data-no-checkbox-label]")){
                   checkboxLabel = '';
                }        

                var min = parseInt($this.data("min")) || 0, max = parseInt($this.data("max")) || 100,
                disabled = $this.is("[data-disabled]"),
                initial = $this.data("initial") || ($this.is("[data-single]") ? "0" : "0,0"),
                format = $this.data("format") || {
                    decimals: 0,
                    prefix: '€ ',
                    postfix: ',-'
                };

                var step = parseInt($this.data("step")) || 1;

                var initialDisabled = false;
                if (!$this.data("initial") || $this.is("[data-initially-off]")) {
                    initialDisabled = true;
                }

                if (isNaN(initial) && !/([\d\.])+,([\d\.])+/.test(initial)) {
                    initial = $this.is("[data-single]") ? "0" : "0,0";
                }

                var checkboxContainer = $this.data('checkbox-container') || null;
                var initialValues = privateFunctions.splitValues(initial);
                var initialValue = initialValues.length > 1 ? "0,0" : "0";
                var secondLabelAdditionalClasses = initialValues.length == 1 ? "hide" : "";
                
                if(!!$this.is("[data-single]")){
                    initialValue = "0";
                    secondLabelAdditionalClasses = "hide";
                    if(initialValues.length > 1) {
                        initialValues = [initialValues[1]];
                    }
                }

                var hideSecondLabel = initialValues.length == 1;

                var checkboxTemplate = '';


                var labelCountClass = '';
                var checkBoxColClass = '', sliderColClass = '';

                if(hideSecondLabel){
                    labelCountClass = 'one-value';
                    checkBoxColClass = 'small-4';
                    sliderColClass = 'small-8';
                }
                else{
                    labelCountClass = 'two-values';
                    checkBoxColClass = 'small-5';
                    sliderColClass = 'small-7';
                }

                /*
                if($this.hasClass("range-slider-small")){
                    checkboxTemplate = `<div class ="columns large-3 tablet-3 medium-3 ${checkBoxColClass} range-slider-small-label">
                                            <div class ="control checkbox no-icon no-shadow">
                                                <input type="checkbox" id="activate-${inputName}" ${initialDisabled ? '' : 'checked'} />
                                                <label for="activate-${inputName}">${checkboxLabel}</label>
                                            </div>
                                        </div>`;
                }
                else {
                    checkboxTemplate = `<div class ="columns small-12 no-padding slider-label">
                                            <div class ="control checkbox no-icon no-shadow">
                                                <input type="checkbox" id="activate-${inputName}" ${initialDisabled ? '' : 'checked'} />
                                                <label for="activate-${inputName}">${checkboxLabel}</label>
                                            </div>
                                        </div>`;
                }

                if(!!checkboxContainer){
                    checkboxTemplate = '';

                    $(checkboxContainer).append(`<div class ="control checkbox no-icon no-shadow">
                                                    <input type="checkbox" id="activate-${inputName}" ${initialDisabled ? '' : 'checked'} />
                                                    <label for="activate-${inputName}">${checkboxLabel}</label>
                                                </div>`);
                }
//*/

                var label1SizeClasses = '', label2SizeClasses = '', sliderSizeClasses = '', sliderWrapperAdditionalClass = '';


                if($this.hasClass("range-slider-small")){
                    if(hideSecondLabel){
                        secondLabelAdditionalClasses = "hide";
                        /*label1SizeClasses = 'medium-3 small-6';
                        label2SizeClasses = 'hide';
                        sliderSizeClasses = 'medium-6 small-6';


                        if($this.is('[data-wider-portrait]')){
                            label1SizeClasses = 'medium-portrait-3 medium-landscape-4 small-6';
                        }
                        */
                    }
                    else{
                        /*label1SizeClasses = 'medium-3 small-6';
                        label2SizeClasses = 'medium-3 small-12';
                        sliderSizeClasses = 'medium-6 small-6';*/
                    }

                    var colClasses = "large-9 tablet-9 medium-9 " + sliderColClass;

                    if($this.hasClass("range-slider-tour")){
                        colClasses = "small-12 no-padding";
                    }

                    var template = `<div class="row no-margin">
                          ${checkboxTemplate}
                            <div class="columns ${colClasses} range-slider-small-content">
                                <div class="row ${labelCountClass}">
                                    <div class="columns">
                                        <label class="value-1"></label>
                                    </div>
                                    <div class="slider-col columns">
                                        <label class="slider"></label>
                                    </div>
                                    <div class="columns ${secondLabelAdditionalClasses}">
                                        <label class ="value-2"></label>
                                    </div>
                                </div>
                            </div>
                            <input type="hidden" name="${inputName}" value="${initialValue}" />
                        </div>`;
                }
                else {
                    if(hideSecondLabel){
                        secondLabelAdditionalClasses = "hide";
                        /*label1SizeClasses = 'large-4 medium-4 small-12';
                        label2SizeClasses = 'hide';
                        sliderSizeClasses = 'large-8 medium-8 small-12';*/
                        sliderWrapperAdditionalClass = 'no-padding-right';
                    }
                    else {
                        /*label1SizeClasses = 'large-2 medium-3 small-12';
                        label2SizeClasses = 'large-2 medium-3 small-12 medium-push-6 large-push-8';
                        sliderSizeClasses = 'large-8 medium-6 small-12 medium-pull-3 large-pull-2';*/
                    }

                    var template = `<div class="row no-margin">
                            ${checkboxTemplate}
                            
                            <div class="${labelCountClass} range-slider-small-content">
                                <div class="columns">
                                    <label class="value-1"></label>
                                </div>
                                <div class="columns ${secondLabelAdditionalClasses}" style="min-height:50px;min-width:50px;">
                                    <label class ="value-2"></label>
                                </div>
                                <div class="slider-col columns ${sliderWrapperAdditionalClass}">
                                    <label class="slider"></label>
                                </div>
                            </div>
 
                            <input type="hidden" name="${inputName}" value="${initialValue}" />
                        </div>`;


                    /*
                     var template = `<div class="row no-margin">
                            ${checkboxTemplate}

                            <div class="columns no-padding label-1-wrapper">
                                <label class="value-1"></label>
                            </div>
                            <div class="columns ${label2SizeClasses} no-padding label-2-wrapper" style="min-height:50px;min-width:50px;">
                                <label class ="value-2 ${secondLabelAdditionalClasses}"></label>
                            </div>
                            <div class="columns ${sliderSizeClasses} slider-wrapper ${sliderWrapperAdditionalClass}">
                                <label class="slider"></label>
                            </div>

                            <input type="hidden" name="${inputName}" value="${initialValue}" />
                        </div>`;
                    */
                }

                $this.html(template);

                var $sliderElement = $this.find(".slider");
                var sliderElement = $sliderElement[0];

                var value1Label = $this.find(".value-1");
                var value2Label = $this.find(".value-2");
                var inputElement = $this.find("input[type='hidden']");

                /*
                var activateCheckbox = null;
                if(!!checkboxContainer){
                    activateCheckbox = $(checkboxContainer).find(`input[type='checkbox']`);                    
                }
                else{
                    activateCheckbox = $this.find("input[type='checkbox']");
                }
                //*/

                if (!!initialDisabled) {
                    //sliderElement.setAttribute('disabled', true);
                    inputElement.prop('disabled', true);
                }
                else {
                    //sliderElement.removeAttribute('disabled');
                    inputElement.prop('disabled',false);
                }
                
                //*
                $sliderElement.on("click touchstart", function(){
                    console.log("it is comming in here...");
                    if(inputElement.is(':disabled')){
                        //sliderElement.removeAttribute('disabled');
                        inputElement.prop('disabled',false);
                        inputElement.removeAttr('disabled');
                        if(!!eventsPostfix){
                            var eventName = `${window.pixelpoint.pubSub.events.slidersEventEnable}:${eventsPostfix}`;
                            window.pixelpoint.pubSub.publish(eventName);
                        }
                    }
                });
                //*/

                var wNumbFormatter = wNumb(format);

                noUiSlider.create(sliderElement, {
                    start: initialValues,
                    connect: true,
                    range: {
                        'min': min,
                        'max': max
                    },
                    step: step,
                    format: wNumbFormatter
                });

                var updateValue = function () {
                    var values = sliderElement.noUiSlider.get();

                    if (!$.isArray(values))
                        values = [values];

                    if (values.length > 0) {
                        value1Label.text(values[0]);
                        if (values.length > 1) {
                            value2Label.text(values[1]);
                        }
                        var value = privateFunctions.joinValues(values, wNumbFormatter);
                        inputElement.val(value);

                        if(!!eventsPostfix){
                            var eventName = `${window.pixelpoint.pubSub.events.slidersEventChange}:${eventsPostfix}`;
                            window.pixelpoint.pubSub.publish(eventName,[value]);
                        }                          
                    }
                };

                sliderElement.noUiSlider.on('update', function () {
                    updateValue();
                });

                if(initialValues.length > 1 && initialValues[1] > min){
                    value2Label.text(wNumbFormatter.to(initialValues[1]));
                }
                else{
                    value2Label.text(wNumbFormatter.to(max));
                }

                var exposedFunctions = {
                    reset(){
                        sliderElement.noUiSlider.set([0,0]);
                        //activateCheckbox.prop("checked",false).change();
                    }
                };
                $this.data("form-element-functions", exposedFunctions).attr("data-form-element-functions-added", true);

                /*
                activateCheckbox.on('change', function () {
                    var activated = activateCheckbox.is(":checked");
                    if (!activated) {
                        inputElement.val('');
                        sliderElement.setAttribute('disabled', true);
                        inputElement.prop('disabled', true);
                        if(!!eventsPostfix){
                            var eventName = `${window.pixelpoint.pubSub.events.slidersEventDisable}:${eventsPostfix}`;
                            window.pixelpoint.pubSub.publish(eventName);
                        }
                    }
                    else {
                        sliderElement.removeAttribute('disabled');
                        inputElement.prop('disabled', false);
                        if(!!eventsPostfix){
                            var eventName = `${window.pixelpoint.pubSub.events.slidersEventEnable}:${eventsPostfix}`;
                            window.pixelpoint.pubSub.publish(eventName);
                        }
                        updateValue();
                    }
                });
                //*/

                if (!!disabled) {
                    //activateCheckbox.prop("disabled", true);
                    sliderElement.setAttribute('disabled', true);
                    inputElement.prop('disabled', true);
                }

                var toDisableEvent = $this.data("to-disable");
                if (!!toDisableEvent) {
                    window.pixelpoint.pubSub.subscribe(`on:disabler:${toDisableEvent}:disable`, function () {
                        //activateCheckbox.prop("disabled", true);
                        sliderElement.setAttribute('disabled', true);
                        inputElement.prop('disabled', true);

                        if(!!eventsPostfix){
                            var eventName = `${window.pixelpoint.pubSub.events.slidersEventDisable}:${eventsPostfix}`;
                            window.pixelpoint.pubSub.publish(eventName);
                        }
                    });
                    window.pixelpoint.pubSub.subscribe(`on:disabler:${toDisableEvent}:enable`, function () {
                        //activateCheckbox.prop("disabled", false);
                        //if(activateCheckbox.is(":checked")){
                            sliderElement.removeAttribute('disabled');
                            //inputElement.prop('disabled', false);
                            if(!inputElement.is(":disabled")){
                                if(!!eventsPostfix){
                                    var eventName = `${window.pixelpoint.pubSub.events.slidersEventEnable}:${eventsPostfix}`;
                                    window.pixelpoint.pubSub.publish(eventName);
                                }
                            }
                        //}
                    });
                }

            });
        }
    };

    window.ppComponents = window.ppComponents || {};
    window.ppComponents.common = window.ppComponents.common || {};
    window.ppComponents.common.sliders = privateFunctions.initSliders;

    privateFunctions.initSliders($(".range-slider"));
});